import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { _Absenteeism, _AnnotationReport, _SocialResponsibility } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectTHConstantsValue } from "../../../bpm/config/Componentes/SelectTHConstantsValue";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { FileInput } from "../../../theme/Component/FileInput";
import { InputDate } from "../../../theme/Input/InputDate";


export const SocialResponsibility = () => {

    const socialresponsibility = useDataBean(_SocialResponsibility);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [state, setstate] = useState<any>(null);
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAdd, setModalAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)



    useEffect(() => {
        getLista()

    }, [state])


    // const getLista = () => {

    //     socialresponsibility.instance.getSocialResponsibilityCatalogPorPropiedades({ State: 1}, null).then(
    //         (resp: any) => {
    //             if (resp) {
    //                 setLista(resp)
    //             }

    //         }
    //     )

    // }

    const getLista = () => {

        socialresponsibility.instance.getSocialResponsibilityCatalogByPropertiesRender({ State: state }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }




    const create = () => {
        socialresponsibility.setBean({
            State: 1,
            IDEmployee: _single.getAccountID(),

        });
        setSwich(false);
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        socialresponsibility.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        socialresponsibility.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDSocialResponsibility', visible: true },
        { title: 'Funcionario', property: 'AccountName', visible: true },
        // { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Actividad', property: 'TypeSocialResponsibilityName', visible: true },

        { title: 'Fecha Actividad', property: 'ActivityDate', visible: true },
        { title: 'Ubicación', property: 'ActivityLocation', visible: true },
        { title: 'Descripcion', property: 'Description', visible: true },
        { title: 'Horas actividad', property: 'HoursSpent', visible: true },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Responsabiliad Social">
            <div className="row">
                <div className="col-md-6">
                    <label>Estado</label>
                    <select className="form-control" value={state} onChange={(e: any) => { setstate(e.target.value) }} >
                        <option value={NaN}>...</option>
                        <option value={1}>ACTIVO</option>
                        <option value={2}>BORRADOR</option>
                    </select>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={socialresponsibility.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <AccountEditor label="Funcionario" idAccount={socialresponsibility.bean.IDAccount} onChange={(e) => { socialresponsibility.setBean({ ...socialresponsibility.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>
                                {/* <div className="col-md-6">
                                    <label>Tipo de Actividad</label>
                                    <SelectTHConstantsValue code={212} value={socialresponsibility.bean.TypeSocialResponsibility} onChange={(e: any) => { socialresponsibility.setBean({ ...socialresponsibility.bean, "TypeSocialResponsibility": e }) }}></SelectTHConstantsValue>
                                </div> */}
                                <div className="col-md-6">
                                    <label>Tipo de Responsabilidad Social</label>
                                    <SelectTHConstantsValue code={210} value={socialresponsibility.bean.TypeSocialResponsibility} onChange={(e: any) => { socialresponsibility.setBean({ ...socialresponsibility.bean, "TypeSocialResponsibility": e }) }}></SelectTHConstantsValue>
                                </div>
                                {/* <div className="col-md-6">
                                    <InputDate notDate label="Fecha Actividad" name="ActivityDate" value={socialresponsibility.bean.ActivityDate} setDate={(e) => { socialresponsibility.setBean({ ...socialresponsibility.bean, "ActivityDate": e }) }} />
                                </div> */}
                                <div className="col-md-6">
                                    <label>Ubicaciónr: </label>
                                    <input type="text" name="ActivityLocation" className="form-control" value={socialresponsibility.bean.ActivityLocation} onChange={socialresponsibility.handleChange} />
                                </div>
                                {/* <div className="col-md-6">
                                    <label>Horas actividad: </label>
                                    <input type="text" name="HoursSpent" className="form-control" value={socialresponsibility.bean.HoursSpent} onChange={socialresponsibility.handleChange} />
                                </div> */}
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={socialresponsibility.bean.Description} onChange={socialresponsibility.handleChange} />
                                </div>

                            </div>

                        </>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}